<template>
  <div>
    <!-- 申请充值模态框 -->
    <ModalDialog
      :dialogData="rechargeDialogData"
      @dialogConfirm="rechargeHandleConfirm"
      @dialogClose="RechargeDialogClose"
      :checkTitle="checkTitle"
    >
      <template slot="content">
        <el-form
          :model="rechargeFormData"
          :rules="rechargeDialogRules"
          ref="rechargeForm"
          label-position="right"
          label-width="96px"
          v-if="applicationProcess == 1 && isVisible"
        >
          <el-form-item label="金额" prop="money" required>
            <el-input v-model="rechargeFormData.money" placeholder="请输入金额"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="desc" required>
            <el-input type="textarea" v-model="rechargeFormData.desc" placeholder="交易用途，可填服务费"></el-input>
          </el-form-item>
        </el-form>
        <div class="qr-code-wrapper" v-if="applicationProcess == 2">
          <el-button class="copyBtn" size="medium" @click="copyText()">一键复制</el-button>
          <div class="link-title">点击此链接跳转至网银转账页面</div>
          <a ref="copyText" target="_blank" :href="this.inGoldUrl">{{this.inGoldUrl}}</a>
        </div>
        <div class="recharge-success" v-if="applicationProcess == 3">
          <i class="el-icon-success" style="font-size: 40px; color: #409eff;"></i>
          <div class="recharge-success-tips">已发起入金申请，成功后会自动匹配到账</div>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import ModalDialog from "./ModalDialog.vue";
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    inGoldTitle: {
      type: String,
      default: ''
    }
  },
  components: {
    ModalDialog,
  },
  data() {
    var moneyValidator = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入金额'));
      } else {
        if (this.rechargeDialogRules.money !== '') {
          let moneyReg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
          
          if(!moneyReg.test(value)){
            callback(new Error('金额格式不正确'));
            return;
          }
        }
        callback();
      }
    };
    return {
      isCopy: false,
      inGoldUrl: '',
      rechargeDialogData: {
        visible: false,
        title: "余额充值",
        width: "30%",
        loading: true,
        modal: false,
      },
      checkTitle: '确定',
      applicationProcess: 1,
      rechargeFormData: {
       desc: '',
        money: ''
      },
      rechargeDialogRules: {
        money: [
          // {
          // required: true, message: '请输入金额', trigger: 'blur'
          // },
          { validator: moneyValidator, trigger: 'blur' }
        ],
        desc: [{
          required: true, message: '请输入备注', trigger: 'blur'
        }],
      },
    };
  },
  watch: {
    "isVisible": function(val) {
      this.rechargeDialogData.visible = val
      this.rechargeFormData = {}
      this.applicationProcess = 1
    },
    "rechargeFormData.money": function(val) {
      if(val) {
        this.rechargeDialogData.loading = false
      }else {
        this.rechargeDialogData.loading = true
      }
    },
    "applicationProcess": function(val) {
        if(val == 2 || val == 3) {
            this.checkTitle = '完成'
        }else {
            this.checkTitle = '确定'
        }
    }
  },
  methods: {
    moneyValidator(){},
    copyText() {
      var that = this 
      if(!that.isCopy) {
        var clipboard = new this.clipboard('.copyBtn', {
          target: function() {
            return that.$refs.copyText
          }
        });
      }
      clipboard.on('success', function() {
        that.$message.success('复制成功')
      });
      clipboard.on('error', function() {
        that.$message.success('复制失败')
      });
      that.isCopy = true
    },
    //申请充值确定事件
    rechargeHandleConfirm() {
      switch(this.applicationProcess) {
        case 1: this.rechargeAmount(); break;
        case 2: this.whetherToPay(); break;
        case 3: this.checkRecharge(); break;
        default: break;
      }
    },
    //充值金额
    async rechargeAmount() {
      this.$refs['rechargeForm'].validate((valid) => {
        if(valid) {
          this.rechargeAmountSubmit()
        }
      })
    },
    //充值金额提交
    async rechargeAmountSubmit(){
      try {
        let args = {
          settlementId: this.mxSettlementId,
          companyId: this.mxCompanyId,
          money: parseFloat(this.rechargeFormData.money).toFixed(2),
          desc: this.rechargeFormData.desc
        }
        let result = await this.$api.huifuRecharge(args)
        if(result) {
          this.applicationProcess = 2
          this.inGoldUrl = result.form_url
        }
      } catch (error) {
        console.log(error)
      }
    },
    //确定是否入金成功
    whetherToPay() {
      this.applicationProcess = 3
    },
    //确定完成充值事件
    checkRecharge() {
      this.rechargeDialogData.visible = false
      this.applicationProcess = 1
      this.$emit('emitCheckRecharge', this.rechargeDialogData.visible)
      this.rechargeFormData = {}
    },
    //申请充值关闭事件
    RechargeDialogClose() {
      this.rechargeDialogData.visible = false
      this.rechargeFormData = {}
      this.$emit('emitRechargeDialogClose', this.rechargeDialogData.visible)
      // this.$refs['rechargeForm'].resetFields()
    },
  }
};
</script>
<style lang="stylus" scoped>
.qr-code
  width: 266px
  height: 266px
  margin: 0 auto
  border: 1px solid black
.qr-code-tips
  text-align: center
  margin-right: 100px
  color: #EE0A0A
.recharge-success
  display: flex;
  justify-content: center;
.recharge-success-tips
  font-size: 20px
  margin-top:10px
  padding: 0 10px
.link-title
  text-align: center
  padding-bottom: 10px
  color: red
.copyBtn
  position: relative
  top: -15px
  left: 84%
</style>
